import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Login sahifasidan OLDIN tashkilot branding'ini (nomi/logo/rang) ko'rsatish
// uchun — subdomendan aniqlangan slug bo'yicha ochiq (unauthenticated) endpoint.
export const fetchPublicOrg = createAsyncThunk('org/fetchPublic', async (slug, { rejectWithValue }) => {
  try {
    const res = await axios.get(`${API_URL}/client/auth/org/${slug}`);
    return res.data.organization;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Tashkilot topilmadi');
  }
});

const orgSlice = createSlice({
  name: 'org',
  initialState: {
    slug: null,      // detectSlug()dan aniqlangan (yoki qo'lda kiritilgan) slug
    data: null,       // { name, slug, logo, brandColor, isActive }
    loading: false,
    error: null,
    checked: false,   // birinchi so'rov tugadimi (spinner/ notFound holatini bilish uchun)
  },
  reducers: {
    setSlug: (state, action) => {
      state.slug = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicOrg.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPublicOrg.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.checked = true;
      })
      .addCase(fetchPublicOrg.rejected, (state, action) => {
        state.loading = false;
        state.data = null;
        state.error = action.payload;
        state.checked = true;
      });
  },
});

export const { setSlug } = orgSlice.actions;
export default orgSlice.reducer;
